import { LisioBooleanParameterNames } from "@lisio/lisio-profils";

import { Lisio } from "../../lisio";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function lisioReadingModeResponseMessageHandler(this: Lisio, _datas: string) {
  if (this.textTreeWalker.texts.size <= 0) {
    this.textTreeWalker.getTextes();
  }
  this.adapters
    .get(LisioBooleanParameterNames.READING_MODE)
    ?.adapt(this.textTreeWalker, true);
}

export { lisioReadingModeResponseMessageHandler };
